export default "__VITE_ASSET__e5c895c6__"